const devSupportToolConfig = {
  app: 'HCP Support App',
  name: 'dev',
  edsLoginLandingPage:
    'https://app01.dev.tsg.hmhco.com/hcp-support-tool-web/ui/dashboard',
  edsLogoutUrl: 'https://app01.dev.tsg.hmhco.com/edcore/eds-login/logout',
  edsPostLogoutRedirectUrl:
    'https://app01.dev.tsg.hmhco.com/hcp-support-tool-web/',
  edsLoginClientId: '4A611590-2CA8-4F30-AEC1-28CC043FFBFE',
  edsLoginIssuer: ' https://app01.dev.tsg.hmhco.com/hcp-support-login/',
  edsLoginUrl:
    'https://app01.dev.tsg.hmhco.com/edcore/eds-login/login/initializeUri',
  edsServiceUrl: 'https://app01.dev.tsg.hmhco.com/edcore/eds-core-app',
  appEndPointUrl: 'https://app01.dev.tsg.hmhco.com/hcp-support-tool/',
  emailTokenURL:
    'https://hmh-identity-provider.dev.br.hmheng.io/user/signupToken',
  commonIdsUrl: 'https://api.dev.br.internal/ids-grid-api/ids/',
  edsGraphUrl:
    'https://app01.dev.tsg.hmhco.com/edcore/hmheng-eds-api-gateway/graphql',
  hmhIdentityProvider: 'https://hmh-identity-provider.int.br.hmheng.io',
  edcoreGatewayUrl: 'https://hapi.dev.hmhco.com/edcore/hmheng-eds-api-gateway/',
};

module.exports = devSupportToolConfig;
